import { useEffect, useState } from "react";

import JobStatus from "../../../../components/JobStatus";
import { API_BASE_URL, profileImgSrc, base_url } from "../../../../config";
import { getAdminAuthToken } from "../../../../auth/auth";

import Loader from "../../../../components/Loader";
import { Link } from "react-router-dom";

export default function DashboardJobs() {
  const [filterText, setFilterText] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [jobs, setJobs] = useState([]);
  const token = getAdminAuthToken();
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });

  const fetchJobs = async (filterText = "", statusFilter = "", page = 1) => {
    setIsLoading(true);

    const params = new URLSearchParams();
    if (filterText.trim()) params.append("company", filterText);
    if (statusFilter) params.append("status", statusFilter);
    params.append("page", page);

    try {
      const response = await fetch(
        `${API_BASE_URL}/admin/jobs?${params.toString()}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.success) {
        setJobs(result.data);
        setPagination(result.meta);
      } else {
        setJobs([]);
        console.error(result.message);
      }
    } catch (err) {
      console.error("Error:", err);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchJobs(filterText, statusFilter, page);
    }, 500);

    return () => clearTimeout(delay);
  }, [filterText, statusFilter, page]);

  return (
    <>
      <div className="jobs-wrapper-dashboard-page page-wrapper-dashboard-all">
        <h2>Jobs</h2>
        <div className="jobs-filter-wrapper dash-filter-wrapper-all">
          <div className="jobs-filter-wrapper__fields dash-filter-wrapper-all__fields">
            <div className="jobs-filter-wrapper__fields--search dash-filter-wrapper-all__fields--search">
              <label>Filter by name</label>
              <input
                type="search"
                placeholder="Search by job or company name"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
            <div className="select-candidate__fields--select dash-filter-wrapper-all__fields--select">
              <label>Job Status</label>
              <select
                onChange={(e) => setStatusFilter(e.target.value)}
                value={statusFilter}
              >
                <option value="">All Statuses</option>
                <option value="0">Open</option>
                <option value="1">In Review</option>
                <option value="2">Closed</option>
              </select>
            </div>
          </div>
          <div className="jobs-filter-wrapper__new--job dash-filter-wrapper-all__right">
            <Link className="btn-all-white" to="company-new-job">
              Create New
            </Link>
          </div>
        </div>

        <div className="dash-jobs-cards dash-card-wrapper">
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <div className="dash-cards-wrapper-inner dash-cards-wrapper-inner-jobs">
                <div className="job-card card-dash-all card-dash-all-first">
                  <div className="job-card__name">
                    <p>Company</p>
                  </div>
                  <div className="job-card__name">
                    <p>Job Name</p>
                  </div>
                  <div className="job-card__candidates">
                    <p>Candidates</p>
                  </div>
                  <div className="job-card__company--status--jobs">
                    <p>Status</p>
                  </div>
                </div>
                {jobs.length > 0 ? (
                  jobs.map((job, index) => (
                    <Link to={`edit-company-job/${job.id}`} key={index}>
                      <div className="job-card card-dash-all">
                        <div className="job-card__name dash-card__img--name">
                          <img
                            src={
                              job.company_image === null
                                ? profileImgSrc
                                : job.company_image
                            }
                            alt="logo"
                            width={40}
                            height={40}
                          />
                          <div className="job-card__company-info">
                            <h4>{job.company}</h4>
                          </div>
                        </div>
                        <div className="job-card__name">
                          <p>{job.title}</p>
                        </div>
                        <div className="job-card__candidates">
                          {job.candidates.length !== 0 ? (
                            job.candidates.map((avatar, i) => (
                              <img
                                key={i}
                                src={
                                  avatar === null
                                    ? profileImgSrc
                                    : `${base_url}${avatar}`
                                }
                                alt="candidate"
                              />
                            ))
                          ) : (
                            <p>No candidates</p>
                          )}
                          {}
                        </div>
                        <div className="job-card__company--status--jobs">
                          <JobStatus status={job.status} />
                        </div>
                      </div>
                    </Link>
                  ))
                ) : (
                  <div className="job-card__not-found">No jobs found.</div>
                )}
              </div>
              <div className="job-dashboard-pagination pagination-all">
                {Array.from(
                  { length: pagination.last_page },
                  (_, i) => i + 1
                ).map((num) => (
                  <button
                    key={num}
                    className={num === pagination.current_page ? "active" : ""}
                    onClick={() => setPage(num)}
                  >
                    {num}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
